<template>
  <base-section
    id="world-map-view"
  >
    <v-container>
      <base-section-heading title="Partner Conferences & Workshops" />
      <base-section-heading
      divider=null
      >
        ETS'23 is the partner of prestigious and important conferences all around the world. Thanks to the regional liaison chairs who helped to maximize the geographical distribution of ETS'23.
      </base-section-heading>
      <v-slide-group
        id="mover_regional"
      >
        <template v-for="(partner, i) in partners">
          <v-slide-item
            :key="i"
            class="align-self-center"
          >
            <a
              :href="partner.to"
              target="_blank"
            >
              <base-img
                v-bind="partner"
                color="grey"
                contain
                height="50"
                width="128"
              />
            </a>
          </v-slide-item>

          <v-responsive
            v-if="i < 16"
            :key="`divider-${i}`"
            class="text-center"
            height="56"
            width="30"
          >
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
      <br>

      <v-img
      :src="require('@/images/world-map.png')"
      >
      </v-img>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in partnersfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < partnersfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  export default {
    name: 'WorldMapView',

    data: () => ({
      isMobile: false,
      partnersfooter: [
        {
          name: 'Partner Conferences',
          url: 'map',
        },
        {
          name: 'Regional Contacts',
          url: 'regional-contacts',
        },
      ],
      partners: [
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
      ],
    }),
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
    mounted () {
      if (document.getElementById('mover_regional')) {
        //  document.getElementById('mover_regional').children[1].style.overflow = 'visible'
        document.getElementById('mover_regional').children[1].style.whiteSpace = 'no-wrap'
        //  document.getElementById('mover').children[1].style.width = '176'
        document.getElementById('mover_regional').children[1].children[0].classList.add('mover')
      }
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
  }
</script>
